import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay]);

export function initSwiper() {
  // 매장 홈 직원 소개 — 1.7장 센터 + loop + 5초 오토플레이.
  // loop 은 활성 카드 좌우를 채울 슬라이드가 넉넉해야 순서가 안 꼬인다(센터
  // 정렬 + 소수 slidesPerView 라 양쪽 다 필요). 직원이 적으면 swiper 가
  // 슬라이드를 DOM 에서 앞뒤로 옮기며 순서가 뒤섞여 보이므로, 카드 세트를
  // 통째로 복제해 최소 개수를 먼저 채운다(4명까지는 복제 대상 — 1.5장 센터
  // 라 화면에 3장이 걸치고, 여유가 한 장뿐이면 여전히 이동이 눈에 띈다).
  const STAFF_MIN_LOOP_SLIDES = 5;

  document.querySelectorAll('[data-swiper-staff]').forEach((el) => {
    const wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const originals = Array.from(wrapper.children);
    const loop = originals.length > 1;

    if (loop && originals.length < STAFF_MIN_LOOP_SLIDES) {
      while (wrapper.children.length < STAFF_MIN_LOOP_SLIDES) {
        originals.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.staffClone = '';
          wrapper.appendChild(clone);
        });
      }
    }

    const prevEl = el.querySelector('[data-swiper-staff-prev]');
    const nextEl = el.querySelector('[data-swiper-staff-next]');

    new Swiper(el, {
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true,
      speed: 500,
      // 기본 .swiper-button-* 마크업 대신 직접 그린 버튼을 넘긴다 —
      // swiper 아이콘 폰트에 기대지 않고 disabled/lock 클래스만 받는다.
      navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
      loop,
      loopAdditionalSlides: loop ? 2 : 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      watchOverflow: true,
      // 이미지 로드·폰트 적용으로 레이아웃이 늦게 잡혀도 위치를 다시 잡는다.
      observer: true,
      observeParents: true,
    });
  });

  const dataSwiperBanner = document.querySelector('[data-swiper-banner]');
  if (dataSwiperBanner) {
    const swBanner = new Swiper(dataSwiperBanner, {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.salon-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          const realTotal = swiper.slides.length - swiper.loopedSlides * 2;
          const realCurrent = swiper.realIndex + 1;

          return `
            <span class="current">${realCurrent}</span>
            <span class="separator">/</span>
            <span class="total">${total}</span>
          `;
        },
      },
    });
  }
}
